/*
 * Journalisation controlee : active uniquement en developpement,
 * totalement silencieuse en production. Ne jamais y passer de donnees
 * personnelles ni de sante (conservation nulle).
 */

const isDevelopment = process.env.NODE_ENV !== "production";

export const devWarn = (...args) => {
  if (isDevelopment && typeof console !== "undefined" && console.warn) {
    console.warn(...args);
  }
};

export const devDebug = (...args) => {
  if (isDevelopment && typeof console !== "undefined" && console.debug) {
    console.debug(...args);
  }
};
